var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "neu-cards-slider1" },
    [
      _c("b-row", { staticClass: "section centered d-flex neu-cards-slider" }, [
        _c(
          "div",
          { staticClass: "my-auto" },
          [
            _c(
              "b-col",
              { staticClass: "text-center my-auto pt-lg-0 pt-5 pb-sm-5" },
              [_c("h3", [_vm._v(_vm._s(_vm.title))])]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row mx-auto pt-5" },
              _vm._l(_vm.cards, function(card) {
                return _c(
                  "b-col",
                  { key: _vm.cards[card], class: { "card-ctn": true } },
                  [
                    _c(
                      "div",
                      { staticClass: "mx-auto" },
                      [
                        _c("neu-card", {
                          attrs: {
                            src: card.src,
                            title: card.title,
                            subtitle: card.subtitle,
                            titleLines: card.titleLines,
                            subtitleLines: card.subtitleLines,
                            iconColor: _vm.iconsColor
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58f9154f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f9154f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardsFourElements.vue
// module id = 4257
// module chunks = 39